module.exports = __webpack_public_path__ + "files/b34b0c135bfb8666d27061340ce383cd.png";